import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import LoginPage from '../containers/LoginPage';
import App from '../containers/App';

const mapStateToProps = state => ({
  user: state.auth.user,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});


class Authentication extends React.Component {

  static propTypes = {
    user: PropTypes.any,
    history: PropTypes.any,
    location: PropTypes.any,
    match: PropTypes.any,
    component: PropTypes.func,
  };

  static defaultProps = {
    user: false,
  };

  componentDidUpdate = (prevProps, prevState) => {

    if (this.props.user && this.props.user !== prevProps.user)
      this.dispatchRouteNavigation();

  }

  dispatchRouteNavigation() {

    const lastPath = localStorage.getItem('last_path');
    if (lastPath && lastPath !== '/')
      this.props.history.push(lastPath);

    this.props.history.push('/context');

  }

  render() {

    const { user } = this.props;

    return (!user || user.expired) ? <LoginPage /> : <App {...this.props}> {<this.props.component {...this.props} />} </App>;

  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authentication));



// WEBPACK FOOTER //
// ./src/components/RequireAuth.js